import { ApiClientV2Default } from 'utils/api-client/api-client.utils'

import { UserStore } from 'shared/stores/user.store'
import { CountriesStore } from 'shared/stores/countries.store'
import { CurrenciesStore } from 'shared/stores/currencies.store'
import { SellerStore } from 'shared/stores/seller.store'
import { PayerStore } from 'shared/stores/payer.store'
import { PublisherStore } from 'shared/stores/publisher.store'
import { TeamMemberStore } from 'shared/stores/teamMember.store'
import { I18nStore } from 'shared/stores/i18n.store'
import { DocImprintStore } from 'shared/stores/docImprint.store'
import { DocPrivacyStore } from 'shared/stores/docPrivacy.store'
import { DocTermsStore } from 'shared/stores/docTerms.store'
import { PlansStore } from 'shared/stores/plans.store'
import { UserProfilesStore } from 'shared/stores/userProfiles.store'
import { CountriesV2Store } from 'shared/stores/countriesV2.store'
import { ExperimentsStore } from 'shared/stores/experiments.store'
import { TrackingLogsStore } from 'shared/stores/trackingLogs.store'
import { AccountStore } from 'shared/stores/account.store'
import { NaturalPersonsEntityStore } from 'shared/stores/naturalPersonsEntity.store'
import { CompaniesEntityStore } from 'shared/stores/companiesEntity.store'

import { BookingStore } from '../../cabinet/stores/booking.store'
import { BonusPaymentsStore } from '../../cabinet/stores/bonusPayments.store'
import { AppStore } from './appStore'
import { TrackingUserEventsStore } from './trackingUserEvents.store'
import { EmailsStore } from './emails.store'
import { SignUpFormStore } from './signUp.store'
import { ElopagePromosStore } from './elopagePromos.store'
import { SurveyStore } from './survey.store'
import { SessionV2Store } from './sessionV2.store'

export class AppRootStore {
  apiClient: ApiClientV2Default

  userStore: UserStore
  countriesStore: CountriesStore
  currenciesStore: CurrenciesStore
  sellerStore: SellerStore
  payerStore: PayerStore
  publisherStore: PublisherStore
  teamMemberStore: TeamMemberStore
  trackingLogsStore: TrackingLogsStore
  bookingStore: BookingStore
  bonusPaymentsStore: BonusPaymentsStore
  appStore: AppStore
  emailsStore: EmailsStore
  signUpFormStore: SignUpFormStore
  elopagePromosStore: ElopagePromosStore
  surveyStore: SurveyStore
  i18nStore: I18nStore
  docImprintStore: DocImprintStore
  docPrivacyStore: DocPrivacyStore
  docTermsStore: DocTermsStore
  plansStore: PlansStore
  userProfilesStore: UserProfilesStore
  countriesV2Store: CountriesV2Store
  sessionV2Store: SessionV2Store
  experimentsStore: ExperimentsStore
  trackingUserEventsStore: TrackingUserEventsStore
  accountStore: AccountStore
  naturalPersonsEntityStore: NaturalPersonsEntityStore
  companiesEntityStore: CompaniesEntityStore

  constructor() {
    this.apiClient = new ApiClientV2Default()

    this.userStore = new UserStore()
    this.countriesStore = new CountriesStore()
    this.currenciesStore = new CurrenciesStore()
    this.sellerStore = new SellerStore()
    this.payerStore = new PayerStore()
    this.publisherStore = new PublisherStore()
    this.teamMemberStore = new TeamMemberStore()
    this.trackingLogsStore = new TrackingLogsStore()
    this.bookingStore = new BookingStore()
    this.bonusPaymentsStore = new BonusPaymentsStore()
    this.appStore = new AppStore()
    this.emailsStore = new EmailsStore()
    this.signUpFormStore = new SignUpFormStore()
    this.elopagePromosStore = new ElopagePromosStore()
    this.surveyStore = new SurveyStore()
    this.i18nStore = new I18nStore()
    this.docImprintStore = new DocImprintStore()
    this.docPrivacyStore = new DocPrivacyStore()
    this.docTermsStore = new DocTermsStore()
    this.plansStore = new PlansStore()
    this.userProfilesStore = new UserProfilesStore()
    this.countriesV2Store = new CountriesV2Store(this)
    this.experimentsStore = new ExperimentsStore()
    this.trackingUserEventsStore = new TrackingUserEventsStore(this)
    this.sessionV2Store = new SessionV2Store(this)
    this.accountStore = new AccountStore(this)
    this.naturalPersonsEntityStore = new NaturalPersonsEntityStore(this)
    this.companiesEntityStore = new CompaniesEntityStore(this)
  }
}
